<script lang="ts" setup>
const props = defineProps<{
  showBreadcrumb: boolean
  heading: string
  headingType: string
  headingStyle: string
  stripe: string
  text: string
  linkAlt: string
  linkTitle: string
  link: string
}>()

const breadcrumb = useBreadcrumbLinks()

const { options, isEditing } = defineBlokkli({
  bundle: 'text_indented_stripe',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const stripeShape = computed(() => {
  return '#brandshape-' + props.stripe.split('_')[0]
})

const stripeColorMain = computed(() => {
  return props.stripe.split('_')[1]
})

const stripeColorAccent = computed(() => {
  return props.stripe.split('_')[2]
})
</script>

<template>
<!-- DISRUPTOR: Pikettdienst, mit Stripe -->

<div class="etx-container Container" :class="paragraphClassList">
  <div class="etx-center Center">

    <div class="etx-flex Flex tab-s:gv-0">

      <div class="etx-flex__item Flex__item tab-s:c-0 show-0 tab-s:show-1">

        <div class="BrandshapeWrapper falling-off-left desk-l:falling-off-max-left" :class="entranceClassList">

          <div class="Brandshape" :data-color-main="stripeColorMain" :data-color-accent="stripeColorAccent">
            <svg width="208" height="208">
              <use :xlink:href="stripeShape"></use>
            </svg>
          </div>

        </div>

      </div>

      <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-7 tab-s:ml-2 tab-m:ml-3 tab-l:ml-4">

        <!-- Breadcrumb -->
        <NuxtPageDependency>
          <Breadcrumb :isEditing="isEditing" :links="breadcrumb" v-if="showBreadcrumb"/>
        </NuxtPageDependency>

        <div class="etx-spacer Spacer h-25"></div>

        <div class="etx-card Card bg-secondary" data-angle-position="top-right" data-angle-color="orange" :class="entranceClassList">

          <div class="etx-card__item Card__item ph-150 pv-150">

            <div class="etx-text Text" :class="entranceClassList">
              <h4 v-if="heading && headingType == 'h4'" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h4>
              <h3 v-else-if="headingType == 'h3'" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h3>
              <h2 v-else="headingType == 'h2'" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h2>
              <HelperHtmlRenderer :htmlContent="text"/>
            </div>

            <div class="etx-button-list ButtonList">

              <a class="etx-button Button focus" :href="`tel:${link}`" :title="linkAlt">
                <div class="etx-button__icon Button__icon">
                  <i class="far fa-phone"></i>
                </div>
                <div class="etx-button__text Button__text">
                  <span>{{ linkTitle }}</span>
                </div>
              </a>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>
</template>
